export enum LicenseType {
  HaynesPro = 'haynespro'
}
